import axios from 'axios'
import { SITE_CONFIG } from 'common/endpoints'
import { FETCH_SITE_CONFIG_SUCCESS } from './types'

// TODO: NOT USED ATM
export const fetchInitialData = dispatch =>
  axios.get(SITE_CONFIG, { withCredentials: true }).then(({ data }) => {
    dispatch({
      type: FETCH_SITE_CONFIG_SUCCESS,
      data,
    })
  })
